import React, { useEffect, useState } from 'react';
import Layout2 from '../layouts/Layout2';
import { Helmet } from 'react-helmet';
import Swal from 'sweetalert2';
import { Link, useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import '../App.css';

const KyatToWon = () => {
    const navigate = useNavigate();
    const [banks, setBanks] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const endpointURL = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE;
    
    const getBanks = async (e) => {
        try {
            const response = await fetch(endpointURL + '/api/v1/kyat-to-won-banks', {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const result = await response.json();
            if (result.status === true) {
                setBanks(result.data);
                setIsLoading(false);
            }
        } catch (error) {
            Swal.fire({
                title: error.message,
                width: 450,
            });
        }
    }
    
    useEffect(() => {
        if (localStorage.getItem('token') == null || localStorage.getItem('token') == "") {
            Swal.fire({
                text: "Telegram ဖြင့် Login ဝင်ပါ",
                width: 400,
            });
            navigate("/");
        }
        if (!submitted) {
            setIsLoading(true);
            setSubmitted(true);
            getBanks();
        }
    }, []);
    
    return (
        <>
            <Layout2 pageType={"ကျပ်ပေးဝမ်ယူ"}>
                <Helmet>
                    <title>KyatToWon - Payment</title>
                </Helmet>
                <div className="exchange-container">
                    <Link to={"/"} className="exchange-back-link">
                        <i className="lni lni-arrow-left"></i>
                        မူလစာမျက်နှာ သို့
                    </Link>
                    
                    <div className="exchange-header">
                        <p>ငွေလွှဲအမျိုးအစားကို ရွေးပြီး ငွေလွှဲပါ</p>
                        <span className="exchange-step">အဆင့် ၂ မှ ၁</span>
                    </div>
                    
                    <h6 className="exchange-subtitle">ငွေလွှဲမည့် ဘဏ်အမျိုးအစားရွေးပေးပါ</h6>
                    
                    {
                        isLoading ? (
                            <div className="transaction-loading">
                                <Spinner animation="border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner>
                                <p>လုပ်ဆောင်နေသည်...ခဏစောင့်ပါ</p>
                            </div>
                        ) : (
                            <div className="exchange-grid">
                                {banks.map((bank) => (
                                    <div key={bank.id} className="exchange-item">
                                        <Link to={"/kyat-to-won-form/" + bank.id} className='link'>
                                            <img src={bank.image} className="exchange-image" alt='bank type'></img>
                                        </Link>
                                        <p className="exchange-label">{bank.name}</p>
                                    </div>
                                ))}
                            </div>
                        )
                    }
                </div>
            </Layout2>
        </>
    );
}

export default KyatToWon;